// src/config/menuConfig.js
import {
  ShoppingCart, Payment, Inventory, Image, Store,
  People, Person, Palette, LocationOn, Inventory2, LocalOffer,
  Straighten, Category, SubdirectoryArrowRight, BarChart,
  Percent,
  BrandingWatermark,
  CurrencyRupee
} from "@mui/icons-material";
import { Dashboard as DashboardIcon } from "@mui/icons-material";
import Orders from "../Admin/Pages/Order/Orders";
import Payments from "../Admin/Pages/Payment/Payments";
import Products from "../Admin/Pages/Product/Products";
import AddBanner from "../Admin/Pages/Banner/AddBanner";
import Vendors from "../Admin/Pages/Vendor/Vendors";
import AddEmployee from "../Admin/Pages/Employee/AddEmployee";
import Dashboard from "../Admin/Pages/Dashboard/Dashboard";
import Users from "../Admin/Pages/User/Users";
import AddColor from "../Admin/Pages/Color/AddColor";
import AddPinCodeArea from "../Admin/Pages/PinCodeArea/AddPinCodeArea";
import AddGroupMap from "../Admin/Pages/GroupMap/AddGroupMap";
import AddBrand from "../Admin/Pages/Brand/AddBrand";
import AddSize from "../Admin/Pages/Size/AddSize";
import AddCategory from "../Admin/Pages/Category/AddCategory";
import AddSubCategory from "../Admin/Pages/SubCategory/AddSubCategory";
import AddProductCategory from "../Admin/Pages/ProductCategory/AddProductCategory";
import AdminDashboard from "../Admin/Components/AdminDashboard";
import ManageUIColorFont from './../Admin/Pages/ManageUIColorFont/ManageUIColorFont';
import Coupons from './../Admin/Pages/CouponCode/Coupons';
import VendorDashboard from '../Vendor/Pages/Dashboard/Dashboard';
import EmployeeDashboard from '../Employee/Pages/Dashboard/Dashboard';
import EmployeeOrders from '../Employee/Pages/Order/Orders';
import AddProduct from "../Vendor/Pages/Product/AddProduct";
import VendorOrders from '../Vendor/Pages/Order/Orders'
import VendorPayments from '../Vendor/Pages/Payment/Payments'
import ProductOffer from "../Admin/Pages/ProductOffer/ProductOffer";
import DesignerOnDiscount from "../Admin/Pages/DesignerOnDiscount/DesignerOnDiscount";
import AddShippingCharge from "../Admin/Pages/ShippingCharge/AddShippingCharge";
import OrdersWithCustomSize from "../Vendor/Pages/Order/OrdersWithCustomSize";

const menuConfig = [
  { id: 3001, name: "Dashboard", path: "/employee/", icon: DashboardIcon, component: EmployeeDashboard, category: "Employee" },
  { id: 3002, name: "Orders", path: "/employee/orders", icon: ShoppingCart, component: EmployeeOrders, category: "Employee" },
  { id: 201, name: "Dashboard", path: "/vendor/", icon: DashboardIcon, component: VendorDashboard, category: "Vendor" },
  { id: 202, name: "Add Product", path: "/vendor/products", icon: Inventory, component: AddProduct, category: "Vendor" },
  { id: 204, name: "Orders", path: "/vendor/orders", icon: ShoppingCart, component: VendorOrders, category: "Vendor" },
  { id: 206, name: "Orders With Custom Size", path: "/vendor/orders_with_custom_size", icon: ShoppingCart, component: OrdersWithCustomSize, category: "Vendor" },
  { id: 205, name: "Payments", path: "/vendor/payments", icon: Payment, component: VendorPayments, category: "Vendor" },
  { id: 1, name: "Dashboard", path: "/admin/", icon: DashboardIcon, component: Dashboard, category: "Admin" },
  { id: 2, name: "Products", path: "/admin/products", icon: Inventory, component: Products, category: "Admin" },
  { id: 3, name: "Orders", path: "/admin/orders", icon: ShoppingCart, component: Orders, category: "Admin" },
  { id: 4, name: "Payments", path: "/admin/payments", icon: Payment, component: Payments, category: "Admin" },
  { id: 5, name: "Vendors", path: "/admin/vendors", icon: Store, component: Vendors, category: "Admin" },
  { id: 6, name: "Offers", path: "/admin/offers", icon: LocalOffer, component: ProductOffer, category: "Admin" },
  { id: 7, name: "Employee Performances", path: "/admin/employee_performances", icon: BarChart, component: AdminDashboard, category: "Admin" },
  { id: 8, name: "Employees", path: "/admin/employees", icon: People, component: AddEmployee, category: "Admin" },
  { id: 9, name: "Permissions", path: "/admin/group_maps", icon: Inventory2, component: AddGroupMap, category: "Admin" },
  { id: 10, name: "Manage UI Color Font", path: "/admin/manageUIColorFont", icon: Palette, component: ManageUIColorFont, category: "Admin" },
  { id: 11, name: "Coupons", path: "/admin/coupons", icon: Payment, component: Coupons, category: "Admin" },
  { id: 12, name: "Banners", path: "/admin/banners", icon: Image, component: AddBanner, category: "Admin" },
  { id: 21, name: "Designer On Discounts", path: "/admin/designer_on_discount_banner", icon: Percent, component: DesignerOnDiscount, category: "Admin" },
  { id: 22, name: "Additional Charges", path: "/admin/additional_charges", icon: CurrencyRupee, component: AddShippingCharge, category: "Admin" },
  { id: 13, name: "Customers", path: "/admin/customer", icon: Person, component: Users, category: "Admin" },
  { id: 14, name: "PinCode Areas", path: "/admin/pincodeAreas", icon: LocationOn, component: AddPinCodeArea, category: "Admin" },
  { id: 15, name: "Brands", path: "/admin/brands", icon: BrandingWatermark, component: AddBrand, category: "Admin" },
  { id: 16, name: "Sizes", path: "/admin/sizes", icon: Straighten, component: AddSize, category: "Admin" },
  { id: 17, name: "Colors", path: "/admin/colors", icon: Palette, component: AddColor, category: "Admin" },
  { id: 18, name: "Categories", path: "/admin/categories", icon: Category, component: AddCategory, category: "Admin" },
  { id: 19, name: "SubCategories", path: "/admin/subCategories", icon: SubdirectoryArrowRight, component: AddSubCategory, category: "Admin" },
  { id: 20, name: "Product Categories", path: "/admin/productCategories", icon: Inventory2, component: AddProductCategory, category: "Admin" },
];

export default menuConfig;

